module.exports = __webpack_public_path__ + "img/template00.a4d3e99d.png";